import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33b2fe45&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=33b2fe45&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b2fe45",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b2fe45')) {
      api.createRecord('33b2fe45', component.options)
    } else {
      api.reload('33b2fe45', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33b2fe45&scoped=true", function () {
      api.rerender('33b2fe45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/system/setLevel/index.vue"
export default component.exports